export default "__VITE_ASSET__3fdec7cb__"